<template>
    <div>
        <div class="p-12 content-tab fci-scrollbar">
            <!--List data input-->
            <SimpleDataTable
                :headers="headers"
                :items="dataTable"
                :hide-pager="true"
            >
                <template v-slot:action="props">
                    <v-btn icon small class="mx-0" v-if="isAdminQCCampaign(props.item.permission)"
                           @click.stop="editDataItem(props.item)">
                        <img src="/img/edit-2.svg" alt="icon-edit" style="transform: scale(0.9);">
                    </v-btn>
                    <v-btn icon small @click="deleteDataItem(props.item)">
                        <img src="/img/delete-new.svg" alt="icon-delete"
                             style="transform: scale(0.9); padding-left: 1px">
                    </v-btn>
                </template>
            </SimpleDataTable>
            <div class="btn-custom-normal btn-add" @click="isShowAddItem = true" style="border-top: none;"
                 v-show="!isShowAddItem">
                <img src="/img/add-member.svg" alt="icon-add" style="padding-right: 6px">
                {{ $f.tc('addNew') }}
            </div>
            <v-form v-show="isShowAddItem" class="table-add-member" v-model="formValid"
                    ref="form">
                <div class="item-new-member">
                    <v-select
                        v-model="model.source"
                        :rules="formRules.required"
                        :items="sourceOptions"
                        class="input-custom"
                    ></v-select>
                </div>
                <div class="item-new-member">
                    <v-combobox
                        v-model="model.field"
                        class="input-custom"
                        :rules="formRules.required"
                        :items="getDataInputSuggestion"
                        ref="newDataInputField"
                    ></v-combobox>
                </div>
                <div class="item-new-member centerXY">
                    <div class="btn-icon" @click="submit">
                        <img src="/img/save-member-2.svg" alt="icon-save" style="transform: scale(0.9);">
                    </div>
                </div>
            </v-form>
        </div>
        <div class="dialog-footer justify-center" v-if="!hideFooter">
            <div class="btn-primary btn-back" @click="backStep">
                <img class="mr-12" src="/img/arrow-right.svg" alt="icon-back" style="transform: rotate(180deg)">
                {{ $f.tc('back') }}
            </div>
            <div class="btn-primary" @click="nextStep">
                {{ $f.tc('next') }}
                <img class="ml-12" src="/img/arrow-right.svg" alt="icon-next">
            </div>
        </div>
    </div>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import { mapState } from 'vuex'
import SimpleDataTable from '@/components/SimpleDataTable'
import QcCampaignService from '@/services/qc.campaign.service'

const sourceOptions = [
    'customer_properties',
    'data_collection',
    'system'
]

export default {
    name: 'NewQCStep2',
    components: { SimpleDataTable },
    mixins: [
        FormMixin,
        RoleMixin
    ],
    props: {
        hideFooter: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            sourceOptions,
            itemToDelete: false,
            isShowAddItem: false,
            showConfirmOverlay: false,
            model: {
                source: '',
                field: ''
            },
        }
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign,
            isEdit: state => state.campaign.isEdit,
            dataInputSuggestion: state => state.qccampaign.dataInputSuggestion
        }),
        headers () {
            return [
                {
                    text: this.$f.tc('source'),
                    value: 'source'
                },
                {
                    text: this.$f.tc('field'),
                    value: 'field'
                },
                {
                    text: '',
                    value: 'action',
                    sortable: false,
                    type: 'custom',
                    id: 'action'
                }
            ]
        },
        getDataInputSuggestion () {
            if (!this.dataInputSuggestion || !this.model.source) {
                return []
            }
            return this.dataInputSuggestion[this.model.source]
        },
        dataTable () {
            return this.qcCampaign ? this.qcCampaign['data_input'] : []
        }
    },
    mounted () {
        this.getDataInput()
    },
    methods: {
        getDataInput () {
            if (this.qcCampaign) {
                this.$appService.showLoading()
                QcCampaignService.DataInputService.search(this.qcCampaign.id).then(result => {
                    this.$store.commit(this.$actionTypes.qccampaign.UPDATE_DATA_INPUT, result.data)
                    if (this.isShowAddItem) {
                        this.$refs.form.reset()
                        this.isShowAddItem = false
                    }
                }).finally(this.$appService.hideLoading)
            }
        },
        submit (event) {
            if (event) {
                event.preventDefault()
            }
            this.$refs.newDataInputField.blur()
            this.$nextTick(() => {
                this.formValid = this.$refs.form.validate()
                if (this.formValid) {
                    this.createDataInput()
                }
            })
        },
        createDataInput () {
            this.$appService.showLoading()
            QcCampaignService.DataInputService.create(this.qcCampaign.id, this.model).then(() => {
                this.getDataInput()
            }).finally(this.$appService.hideLoading)
        },
        deleteDataItem (item) {
            let deleteMessage = this.$f.tc('confirmDelete', { item: item.field })
            this.$appService.confirm(deleteMessage).then(
                confirm => {
                    if (confirm) {
                        this.$appService.showLoading()
                        QcCampaignService.DataInputService.delete(this.qcCampaign.id, item.id).then(
                            () => {
                                this.$appService.toastSuccess(this.$f.tc('actionSuccessful', {
                                    action: this.$t('delete'),
                                    item: item.field
                                }))
                                this.itemToDelete = false
                                this.getDataInput()
                            }
                        ).catch(() => {
                            this.$appService.hideLoading()
                        })
                    }
                }
            )
        },
        nextStep () {
            this.$emit('nextStep')
        },
        backStep () {
            this.$emit('backStep')
        }
    },
}
</script>
<style scoped lang="scss">
.campaign-info {
    display: block;
    margin: 0 auto;
    width: 100%;
    max-width: 1080px;
}

.campaign-form {
    display: flex;
    flex-direction: column;
    align-items: center;

    .label {
        font-family: "open sans semi", serif;
        margin-bottom: 6px;
        font-size: 13px;
    }
}

.btn-add {
    height: 40px !important;
    border-radius: 0 !important;
    justify-content: left;
    color: #0052CC;
    font-size: 14px;
    font-family: "open sans bold", serif;
    font-style: normal;
    text-align: center;
}

.btn-back {
    margin-right: 8px;
}

.btn-add-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 40px;
    cursor: pointer;

    &:hover {
        background: #1e66d2;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 40px;
            background: #FFFFFF;
            border-radius: 0;
            border: none !important;
            outline: none;
            font-size: 14px;
            padding: 0 10px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.input-custom.v-select {
    ::v-deep {
        .v-input__slot {
            padding: 0 4px 0 10px;
        }

        .v-text-field__details {
            right: 32px !important;
        }
    }
}

.table-add-member {
    border: 1px solid #DADFEC;
    display: flex;
    border-top: none;

    .item-new-member {
        height: 40px;
        border-right: 1px solid #DADFEC;

        &:last-child {
            border-right: none;
        }

        &:nth-child(1) {
            position: relative;
            margin: 0 !important;
            width: 300px;
        }

        &:nth-child(2) {
            margin: 0 !important;
            flex: 1;
        }

        &:nth-child(3) {
            width: 65px;
            margin: 0 !important;
            text-align: center;
        }
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input__control {
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 10px !important;
        top: 14px !important;
    }

    .v-datatable__progress {
        display: none;
    }

    .v-table__overflow {
        border: 1px solid #DADFEC;


        thead tr:not(.v-datatable__progress) {
            height: 40px !important;
            border-bottom: none;
            padding: 0 !important;

        }

        thead tr th {
            text-transform: capitalize !important;
            color: #12274F !important;
            background: #F4F7FE;
            border-right: 1px solid #DADFEC;
            border-bottom: 1px solid #DADFEC;
            padding: 0 10px 0 10px;

            &:last-child {
                border-right: none;
            }
        }

        tbody tr td {
            height: 40px !important;
            border-right: 1px solid #DADFEC;
            padding: 0 10px 0 10px;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 299px;
            }

            &:nth-child(2) {
                flex: 1;
                max-width: 600px;
            }

            &:nth-child(3) {
                width: 66px;
            }
        }
    }
}

@media screen and (min-width: 600px) {
    .campaign-info {
        padding: 20px 0 20px;
    }
}
</style>
